"use strict";

import { debounce } from "lodash";
import { isUpArrowKey, isDownArrowKey, isEnterKey } from "../helpers/keyboardHelpers";
import constants from "../constants";

const setupSelectCityEventListeners = () => {
    let $selectedLocation = null;

    const getLocalitySuggestionsFromServer = ($input) => {
        const value               = $input.val().toLowerCase();
        const $inputParent        = $input.parent();
        const $localityOptionList = $input.siblings(".select-options");
        const $noResults          = $localityOptionList.find(".no-results");

        const getDefaultLocalityOptionsListUrl  = $input.data("get-default-locality-options-list-url");
        const getUserTipedLocalityOptionListUrl = $input.data("get-user-tiped-locality-option-list-url");

        const shouldGetSuggestionsFromServer = value.length >= 3;

        $inputParent.addClass("input-loading");

        $.ajax({
            url: shouldGetSuggestionsFromServer ? getUserTipedLocalityOptionListUrl : getDefaultLocalityOptionsListUrl,
            type: "get",
            dataType: "json",
            data: {
                userInput: value,
            },
            success: function (data) {
                $inputParent.removeClass("input-loading");

                if (!data.localityList) {
                    return;
                }

                //Remove all current items of the list
                $("li", $localityOptionList).remove();

                //Populate the select options with the localities returned from BD
                data.localityList.forEach((locality) => {
                    //Part of the locality name that is the same as the user query will be visually highlighted,
                    //so we need to separate the highlighted and normal text.
                    const cityStateName           = locality.cityName + "/" + locality.stateCode;
                    const highlightedLocalityName = cityStateName.slice(0, value.length);
                    const remainingLocalityName   = cityStateName.slice(value.length);
                    const $localityOption         = $(`<li tabindex="0">
                        <span>${highlightedLocalityName}</span><p>${remainingLocalityName}</p>
                    </li>`);

                    $localityOption.attr("data-locality-option", JSON.stringify(locality));
                    $localityOption.appendTo($localityOptionList);
                });

                if (data.localityList.length === 0) {
                    $noResults.show();
                } else {
                    $noResults.hide();
                }
            },
            error: function (err) {
                $inputParent.removeClass("input-loading");

                console.error(err);

                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
        });
    };

    const filterDebouncedOptions      = debounce(getLocalitySuggestionsFromServer, 300);
    const $zeroProductsModalContainer = $(".js-zero-products-modal");

    const closeSelectCity = () => {
        const $selectCityToggle = $(".js-toggle-select-city.open");

        if (!$selectCityToggle || !$selectCityToggle.length) {
            return;
        }

        $selectCityToggle.removeClass("open");

        document.body.style.overflow = "auto";
    };

    const handleLocationSelectedByUser = () => {
        const $selectCityForm     = $(".js-search-select-city-form");
        const url                 = $selectCityForm.attr("action");
        const localityOption      = $selectCityForm.find("li.active").attr("data-locality-option");
        const localityOptionName  = $selectCityForm.find("li.active").text();
        const $selectLocalityMain = $(".select-locality-main");
        const shouldTrigger       = $selectLocalityMain.attr("data-trigger-select");
        const dataRedirect        = $selectLocalityMain.attr("data-redirect-url");
        const selectedLocation    = JSON.parse(localityOption);

        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: {
                localityOption: localityOption,
                source: $selectCityForm.parents(".js-header-lp").length !== 0 ? constants.pageDesignerIds.landingpage : null
            },
            success: (data) => {
                const { success, shouldOpenLocalityUnavailableProductsModal, shouldOpenLandingPageUnavailableModal, shouldRedirectToMyAccount, redirectUrl } = data;

                if (shouldOpenLocalityUnavailableProductsModal || shouldOpenLandingPageUnavailableModal) {
                    closeSelectCity();
                    $zeroProductsModalContainer.toggleClass("show", true);
                    $(".js-selected-city-name", $zeroProductsModalContainer).text(localityOptionName);
                    return;
                }

                if (success && shouldTrigger && dataRedirect && selectedLocation) {
                    const redirectUrlWithPid = dataRedirect.concat(`&localityId=${selectedLocation.regulatoryCode}`);

                    location.href = redirectUrlWithPid;
                } else if (success && shouldRedirectToMyAccount) {
                    location.href = redirectUrl;
                } else if (success && !shouldTrigger) {
                    location.reload();
                }
            },
            error: (error) => {
                if (error.responseJSON.redirectUrl) {
                    window.location.href = error.responseJSON.redirectUrl;
                }
            },
        });
    };

    $(".js-modal-close, .js-modal-backdrop", $zeroProductsModalContainer).on("click", function () {
        $zeroProductsModalContainer.toggleClass("show", false);
    });

    $(".js-toggle-select-city").on("click", function () {
        const $selectCityToggle = $(this);
        const $searchCityInput  = $selectCityToggle.siblings(".js-select-city").find(".js-search-select-city input");

        $selectCityToggle.toggleClass("open");

        $selectCityToggle.hasClass("open")
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";

        //Automatically focus on the input field, the timeout is necessary because of the animation transition not allowing the element to be focusable
        //Before it finishes
        setTimeout(() => $searchCityInput.trigger("focus"), 500);
    });

    $(".js-toggle-select-city").on("keypress", function (event) {
        if (event.keyCode === constants.KEYBOARD_KEYS.ENTER) {
            $(".js-toggle-select-city").trigger("click");
        }
    });

    $(".js-close-select-city-form").on("click", function () {
        const $selectCityToggle = $(this).closest(".select-city").parent().find(".js-toggle-select-city");

        $selectCityToggle.trigger("click");
    });

    $(".js-search-select-city-form").on("submit", function (e) {
        e.preventDefault();
    });

    // show select options on focus
    $(".js-search-select-city input.selected-option").on("focus", function () {
        const $localityOptionList = $(this).siblings(".select-options");

        $localityOptionList.show();
        filterDebouncedOptions($(this));
    });

    // select an option on click
    $("body").on("click", ".js-search-select-city .select-options li", function () {
        const selectedOption = $(this).data("locality-option");

        $(this).parent().siblings("input.selected-option").val(selectedOption.cityName + "/" + selectedOption.stateCode);
        $(this).addClass("active").siblings().removeClass("active");
        $(this).parent().hide();
        handleLocationSelectedByUser();
    });

    $("body").on("keypress", ".js-search-select-city .select-options li", function () {
        if (event.keyCode === constants.KEYBOARD_KEYS.ENTER) {
            $(this).trigger("click");
        }
    });

    // handle key up events
    $(".js-search-select-city input.selected-option").on("keyup", function (keyEvent) {
        const $localityOptionList = $(this).siblings(".select-options");
        const $options            = $localityOptionList.find("li");

        $localityOptionList.show();

        if (!isUpArrowKey(keyEvent) && !isDownArrowKey(keyEvent)) {
            filterDebouncedOptions($(this));
        }

        if (isUpArrowKey(keyEvent)) {
            if ($selectedLocation === null) {
                $selectedLocation = $options.last();
            } else {
                $selectedLocation.removeClass("active");
                $selectedLocation = $selectedLocation.prevAll(":visible").first();

                if ($selectedLocation.length === 0) {
                    $selectedLocation = $options.last();
                }
            }

            $localityOptionList.scrollTop(
                $selectedLocation.offset().top - $localityOptionList.offset().top + $localityOptionList.scrollTop() - 10
            );

            $selectedLocation.addClass("active");
            const locationData = $selectedLocation.data("locality-option");

            $(this).val(locationData.cityName + "/" + locationData.stateCode);
        } else if (isDownArrowKey(keyEvent)) {
            if ($selectedLocation === null) {
                $selectedLocation = $options.first();
            } else {
                $selectedLocation.removeClass("active");
                $selectedLocation = $selectedLocation.nextAll(":visible").first();

                if ($selectedLocation.length === 0) {
                    $selectedLocation = $options.first();
                }
            }

            $localityOptionList.scrollTop(
                $selectedLocation.offset().top - $localityOptionList.offset().top + $localityOptionList.scrollTop() - 10
            );

            $selectedLocation.addClass("active");
            const locationData = $selectedLocation.data("locality-option");

            $(this).val(locationData.cityName + "/" + locationData.stateCode);
        }

        if (isEnterKey(keyEvent)) {
            $selectedLocation = $options.filter(".active");

            if ($selectedLocation.length !== 0) {
                const locationData = $selectedLocation.data("locality-option");

                $(this).val(locationData.cityName + "/" + locationData.stateCode);
                $(this).siblings(".select-options").hide();
                handleLocationSelectedByUser();
            }
        }
    });

    // hide select options on click outside
    $(document).on("click", function (event) {
        if (!$(event.target).closest(".js-search-select-city").length) {
            $(".js-search-select-city .select-options").hide();
        }
    });
};

const handleTriggerSelect = () => {
    const $selectLocalityMain = $(".select-locality-main");
    const shouldTrigger       = $selectLocalityMain.attr("data-trigger-select");

    if (shouldTrigger === "true") {
        $(".js-toggle-select-city").toggleClass("open");
        $(".js-search-select-city").find(".select-options").css("display", "block");
    }
};

const initCitySelectionListeners = () => {
    setupSelectCityEventListeners();
    handleTriggerSelect();
};

export default initCitySelectionListeners;
